module.exports = __webpack_public_path__ + "img/lg_d.c5ab988c.png";